import React, { Component } from "react";
import { Form, Modal, Radio, Row, Col, Checkbox } from 'antd';
import NHFetch from "../../../utils/NHFetch";
import Viewer from 'react-viewer';

const FormItem = Form.Item;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            previewVisible: false,
            blyy: '',
            fj: [],
        }
    }
    componentWillMount() {
        //根据lstdid 获取办理原因
        let initFormData = this.props.initFormData;
        NHFetch(`/swbl/lstd/lstdblyy/${initFormData.PKID}/getBlyyStr`, "get").then(res => {
            if (res) {
                this.setState({ blyy: res.data });
            }
        })

        NHFetch(`/swbl/lstd/${initFormData.PKID}/getFjList`, "get").then(res => {
            if (res) {
                this.setState({ fj: res.data });
            }
        })

    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }
    // (这个地方包含处理审核和新增的图片预览逻辑。)点击文件链接或预览图标时的回调
    handlePreview = (fj, fjid) => {
        let isImage = true;
        const name = fj.name || fj.fjmc;
        fjid = fjid || fj.response.data.ssbh
        if (
            !this.setJudge(name, this.state.judgeImgList)
        ) {
            isImage = false;
        }

        if (isImage) {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    handleCancel = () => this.setState({ previewVisible: false });

    render() {
        const initFormData = this.props.initFormData;
        return (
            <div>
                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}> 姓名(学号)：</Col>
                    <Col span={8}>{initFormData.XH ? `${initFormData.XM}(${initFormData.XH})` : ''}</Col>
                    <Col span={4} style={{ textAlign: 'right' }}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{ textAlign: 'right' }}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{ textAlign: 'right' }}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>

                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}>办理原因：</Col>
                    <Col span={20}>{this.state.blyy}</Col>
                </Row>

                {
                    initFormData.QTBLYY && this.state.blyy.includes(",其他") &&
                    <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}>其他原因：</Col>
                        <Col span={20}>{initFormData.QTBLYY}</Col>
                    </Row>
                }


                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}>申请类型：</Col>
                    <Col span={20}></Col>
                </Row>
                {
                    initFormData.HJXFZSFJE &&
                    <Row gutter={24} style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}></Col>
                        <Col span={20}>
                            <Checkbox value={'01'} checked={true} disabled={true} >
                                缓交学费住宿费&nbsp;
                            </Checkbox>
                            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>缓交金额(元)&nbsp;: </span>
                            {initFormData.HJXFZSFJE}元
                        </Col>
                    </Row>
                }
                {
                    initFormData.SHBTJE &&
                    <Row gutter={24} style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}></Col>
                        <Col span={20}>
                            <Checkbox value={'01'} checked={true} disabled={true}>
                                生活补贴&nbsp;
                            </Checkbox>
                            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>补贴金额(元)&nbsp;: </span>
                            {initFormData.SHBTJE}元
                        </Col>
                    </Row>
                }
                {
                    initFormData.SHYPJE &&
                    <Row gutter={24} style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}></Col>
                        <Col span={20}>
                            <Checkbox value={'01'} checked={true} disabled={true}>
                                生活用品&nbsp;
                            </Checkbox>
                            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>补贴金额(元)&nbsp;: </span>
                            {initFormData.SHYPJE}元
                        </Col>
                    </Row>
                }
                {
                    initFormData.LFBZJE &&
                    <Row gutter={24} style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}></Col>
                        <Col span={20}>
                            <Checkbox value={'01'} checked={true} disabled={true}>
                                路费补助&nbsp;
                            </Checkbox>
                            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>补贴金额(元)&nbsp;: </span>
                            {initFormData.LFBZJE}元
                        </Col>
                    </Row>
                }
                {
                    initFormData.QTBZJE &&
                    <Row gutter={24} style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}></Col>
                        <Col span={20}>
                            <Checkbox value={'01'} checked={true} disabled={true}>
                                其他补助&nbsp;
                            </Checkbox>
                            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>补贴金额(元)&nbsp;: </span>
                            {initFormData.QTBZJE}元
                        </Col>
                    </Row>
                }
                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}>申请助学贷款类型：</Col>
                    <Col span={20}></Col>
                </Row>
                {
                    initFormData.SYDDKJE &&
                    <Row gutter={24} style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}></Col>
                        <Col span={20}>
                            <Checkbox value={'01'} checked={true} disabled={true}>
                                生源地信用助学贷款&nbsp;
                            </Checkbox>
                            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>贷款金额(元)&nbsp;: </span>
                            {initFormData.SYDDKJE}元
                            <span
                                style={{ color: 'rgba(0, 0, 0, 0.85)' }}>&nbsp;&nbsp;贷款银行&nbsp;: </span>
                            {initFormData.DKYHMC}
                        </Col>
                    </Row>
                }
                {
                    /*  initFormData.GXDKJE &&
                     <Row gutter={24} style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                         <Col span={4} style={{textAlign:'right'}}></Col>
                         <Col span={20}>
                             <Checkbox value={'01'} checked={true} disabled={true}>
                                 高校助学贷款&nbsp;
                             </Checkbox>
                             <span style={{color: 'rgba(0, 0, 0, 0.85)'}}>贷款金额(元)&nbsp;: </span>
                             {initFormData.GXDKJE}元
                         </Col>
                     </Row> */
                }

                <Row gutter={24}>
                    <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                        style={{ color: 'rgba(0, 0, 0, 0.85)' }}>材料证明&nbsp;: </span></Col>
                    <Col span={20}>
                        {this.state.fj.map((elem, index) => {
                            return (
                                <div style={{ marginBottom: '20px' }}>
                                    <a onClick={() => {
                                        this.handlePreview(elem, elem['fjid']);
                                    }}>{elem['fjmc']}</a>
                                </div>
                            )
                        })
                        }
                    </Col>
                </Row>

                <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                    <Col span={4} style={{ textAlign: 'right' }}>申请理由：</Col>
                    <Col span={20}>{initFormData.SQSM}</Col>
                </Row>


                {initFormData.SJLY == '2' && <div>
                    <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZTMC}</Col>
                        <Col span={4} style={{ textAlign: 'right' }}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                    </Row>
                    <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                    </Row>
                </div>}
                <Viewer
                    visible={this.state.previewVisible}
                    onClose={this.handleCancel}
                    images={[{ src: this.state.previewImage, alt: '' }]}
                />
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/lstd/ViewForm.js